// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2512":"3056116d","8947":"0e607ace"}[chunkId] + ".chunk.css";
};